import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/formFocusGuard";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
const render = () => root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Keep the published HTML visible while the matching public route chunk loads.
// System routes and booking keep their existing startup flow.
const published = document.getElementById('jvc-public-data');
if (published) {
  const blog = window.location.pathname === '/blog' || window.location.pathname.startsWith('/blog/');
  const ready = blog ? import('./pages/cms/BlogPublic') : import('./pages/cms/CmsPublicPage');
  ready.then(render, render);
} else {
  render();
}
